import service from '@/utils/request'
var version = "web_v1"
//登录
export function postLogin(data) {
  return service.request({
    url: '/api/index/login',
    method: 'post',
    header: {
      "version": version
    },
    data: data
  })
}

// 注册
export function postReg(data) {
  return service.request({
    url: '/api/index/reg',
    method: 'post',
    header: {
      "version": version
    },
    data: data
  })
}

// 注册短信验证码 /api/index/reg_sms
export function postRegSms(data) {
  return service.request({
    url: ' /api/index/reg_sms',
    method: 'post',
    header: {
      "version": version
    },
    data: data
  })
}

// 短信登录
export function postMsgLogin(data) {
  return service.request({
    url: ' /api/index/login_check_sms',
    method: 'post',
    header: {
      "version": version
    },
    data: data
  })
}

// 短信登录发送验证码
export function postMsgLoginCheck(data) {
  return service.request({
    url: ' /api/index/login_sms',
    method: 'post',
    header: {
      "version": version
    },
    data: data
  })
}

// index 首页数据
export function postIndex(data) {
  return service.request({
    url: '/api/page/get_index',
    method: 'post',
    header: {
      "version": version
    },
    data: data
  })
}
// 搜索
export function postSearch(data) {
  return service.request({
    url: '/api/page/search_article_info',
    method: 'post',
    header: {
      "version": version
    },
    data: data
  })
}
// 剧院概览
export function postOverview(data) {
  return service.request({
    url: '/api/page/get_index_info',
    method: 'post',
    header: {
      "version": version
    },
    data: data
  })
}

// 新闻列表
export function postNewsList(data) {
  return service.request({
    url: '/api/page/get_article_info',
    method: 'post',
    header: {
      "version": version
    },
    data: data
  })
}

// 文章详情
export function postNewsDetail(data) {
  return service.request({
    url: '/api/page/get_article_detail',
    method: 'post',
    header: {
      "version": version
    },
    data: data
  })
}

// 演出中心
export function postCenter(data) {
  return service.request({
    url: '/api/page/get_center',
    method: 'post',
    header: {
      "version": version
    },
    data: data
  })
}

// 演出中心 获取更多剧目列表
export function postCenterPlayList(data) {
  return service.request({
    url: '/api/page/get_goods_list',
    method: 'post',
    header: {
      "version": version
    },
    data: data
  })
}

// 云剧场
export function postCloudTheater(data) {
  return service.request({
    url: '/api/page/get_cloud_theater',
    method: 'post',
    xhrFields: {
      withCredentials: true
    },
    header: {
      "version": version
    },
    data: data
  })
}
// 云剧场/详情
export function postCloudTheaterDetail(data) {
  return service.request({
    url: '/api/order/get_cloud_theater_detail',
    method: 'post',
    xhrFields: {
      withCredentials: true
    },
    header: {
      "version": version
    },
    data: data
  })
}
// 文创产品
export function postGoods(data) {
  return service.request({
    url: '/api/goods/get_goods_list',
    method: 'post',
    xhrFields: {
      withCredentials: true
    },
    header: {
      "version": version
    },
    data: data
  })
}

// 产品详情
export function postGoodsDetail(data) {
  return service.request({
    url: '/api/goods/get_goods_detail',
    method: 'post',
    xhrFields: {
      withCredentials: true
    },
    header: {
      "version": "web_v1"
    },
    data: data
  })
}
// 个人中心

export function postAdmin(data) {
  return service.request({
    url: '/api/user/index',
    method: 'post',
    xhrFields: {
      withCredentials: true
    },
    header: {
      "version": "web_v1"
    },
    data: data
  })
}

// 个人中心-新建地址
export function postNewAddress(data) {
  return service.request({
    url: '/api/user/add_address',
    method: 'post',
    xhrFields: {
      withCredentials: true
    },
    header: {
      "version": "web_v1"
    },
    data: data
  })
}

// 个人中心-修改地址
export function postEidtAddress(data) {
  return service.request({
    url: '/api/user/edit_address',
    method: 'post',
    xhrFields: {
      withCredentials: true
    },
    header: {
      "version": "web_v1"
    },
    data: data
  })
}

// 个人中心-修改密码
export function postEidtPassword(data) {
  return service.request({
    url: '/api/user/edit_password',
    method: 'post',
    xhrFields: {
      withCredentials: true
    },
    header: {
      "version": "web_v1"
    },
    data: data
  })
}
// 商务合作 出租
export function postBusinessRent(data) {
  return service.request({
    url: '/api/page/get_business_rent',
    method: 'post',
    xhrFields: {
      withCredentials: true
    },
    header: {
      "version": "web_v1"
    },
    data: data
  })
}
// 商务合作 品牌加盟
export function postBusinessBrand(data) {
  return service.request({
    url: '/api/page/get_business_brand',
    method: 'post',
    xhrFields: {
      withCredentials: true
    },
    header: {
      "version": "web_v1"
    },
    data: data
  })
}

// 艺术教育 (小铃铛艺术团)
export function postEducation(data) {
  return service.request({
    url: '/api/page/get_education',
    method: 'post',
    xhrFields: {
      withCredentials: true
    },
    header: {
      "version": "web_v1"
    },
    data: data
  })
}
// 艺术教育 (在线教育)
export function postEducation2(data) {
  return service.request({
    url: '/api/page/get_education_2',
    method: 'post',
    xhrFields: {
      withCredentials: true
    },
    header: {
      "version": "web_v1"
    },
    data: data
  })
}


// WEBPACK FOOTER //
// ./src/api/main.js